"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentInstanceNameFor = agentInstanceNameFor;
const NAME = /^[a-z0-9][a-z0-9.-]{0,199}(_[0-9]{1,5})?$/;
function agentInstanceNameFor(url) {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch (_a) {
        return null;
    }
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:")
        return null;
    const name = parsed.port
        ? `${parsed.hostname}_${parsed.port}`
        : parsed.hostname;
    if (!parsed.hostname ||
        !NAME.test(name) ||
        name.includes("..") ||
        name === "default")
        return null;
    return name;
}
